export enum DeclineReasonDirection {
  COMPANY = 'company',
  APPLICANT = 'applicant',
  BOTH = 'both',
}
